import { createRequestTypes } from '../utils';

export const ORDER_ITEM_LIST = createRequestTypes('orderItem/ORDER_ITEM_LIST');
export const SAVE_ORDER_ITEM = createRequestTypes('orderItem/SAVE_ORDER_ITEM');
export const DELETE_ORDER_ITEM = createRequestTypes('orderItem/DELETE_ORDER_ITEM');
export const ORDER_PLANNER_LIST = createRequestTypes('orderItem/ORDER_PLANNER_LIST');
